// Ref theme.liquid before  </body> 

(function () {
  function moveButtonOnce() {
    const writeWrapper = document.querySelector('.oke-w-reviews-writeReview');
    const headerTarget = document.querySelector('.oke-w-header-content-block--oneThird.oke-w-header-content-block--left');
    if (!writeWrapper || !headerTarget) return false;
    if (headerTarget.contains(writeWrapper)) return true;
    headerTarget.appendChild(writeWrapper);
    return true;
  }

  // try immediately and on DOM ready
  if (document.readyState !== 'loading') moveButtonOnce();
  else document.addEventListener('DOMContentLoaded', moveButtonOnce);

  // observe for async insertion / re-renders
  const observer = new MutationObserver(() => {
    moveButtonOnce();
    // keep observing in case the widget re-renders
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();